/**
 * Rend lisible la syntaxe `opening_hours` d'OpenStreetMap, **sans perte**.
 *
 * On ne traduit que ce qui est certain : codes de jours, heures, « off ». Toute expression non
 * reconnue (« PH », « sunrise-sunset », « Sa[1] »…) est laissée telle quelle plutôt que réécrite
 * de travers — des horaires faux seraient pires que des horaires bruts.
 */
const DAYS: Readonly<Record<string, string>> = {
  Mo: 'lundi',
  Tu: 'mardi',
  We: 'mercredi',
  Th: 'jeudi',
  Fr: 'vendredi',
  Sa: 'samedi',
  Su: 'dimanche',
};

export function formatOsmOpeningHours(value: string): string {
  return value
    .trim()
    .replace(/\b(Mo|Tu|We|Th|Fr|Sa|Su)\b/g, (day) => DAYS[day] ?? day)
    .replace(/\b(\d{1,2}):(\d{2})\b/g, (_, hours: string, minutes: string) =>
      minutes === '00' ? `${Number(hours)}h` : `${Number(hours)}h${minutes}`,
    )
    .replace(/\boff\b/g, 'fermé')
    .replace(/\s*-\s*/g, ' – ')
    .replace(/\s*,\s*/g, ', ')
    .replace(/\s*;\s*/g, ' · ');
}
